"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_blush(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons_Indicators_TOBi-Emojis_Blush",
    "data-name": "Icons+Indicators / TOBi-Emojis / Blush",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 68 68"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(12 12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    d: "M32.38.023h-.156c-.111.089-.245.178-.378.267a14.574,14.574,0,0,1-3.361,1.6A28.906,28.906,0,0,1,24.08,2.961a41.238,41.238,0,0,1-6.632.534,41.439,41.439,0,0,1-6.632-.534A19.3,19.3,0,0,1,2.693,0,2.417,2.417,0,0,0,.756.913,3.927,3.927,0,0,0,0,2.583V8.5c0,.312.022.624.044.913a17.459,17.459,0,0,0,34.806,0c.022-.312.044-.6.044-.913v-5.9A4.935,4.935,0,0,0,34.138.936,2.449,2.449,0,0,0,32.38.023Z",
    transform: "translate(4.518 19.026)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-2",
    "data-name": "Fill",
    d: "M.312,1.758h0A5.225,5.225,0,0,1,0,0V1.758A5.566,5.566,0,0,0,5.564,7.322a14.805,14.805,0,0,1-.646-2.2A5.1,5.1,0,0,1,.312,1.758",
    transform: "translate(0.022 25.793)",
    fill: "#900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    "data-name": "Fill",
    d: "M5.17,1.758h0A5.076,5.076,0,0,1,.638,5.119,16.6,16.6,0,0,1,0,7.322,5.534,5.534,0,0,0,5.5,1.758V0a4.791,4.791,0,0,1-.33,1.758",
    transform: "translate(38.318 25.793)",
    fill: "#900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    "data-name": "Fill",
    d: "M.022,21.342c0,.133-.022.245-.022.378v4.1a5.219,5.219,0,0,0,.312,1.758A5.128,5.128,0,0,0,4.9,30.933a18.038,18.038,0,0,1-.378-2.448c-.025-.311-.044-.6-.044-.913a1.737,1.737,0,0,1,0-.489v-5.43a4.2,4.2,0,0,1,.756-1.669,2.35,2.35,0,0,1,1.936-.912,19.619,19.619,0,0,0,8.123,2.96,41.164,41.164,0,0,0,6.632.534,41.371,41.371,0,0,0,6.632-.534,29.27,29.27,0,0,0,4.384-1.068,14.574,14.574,0,0,0,3.361-1.6c.133-.089.267-.178.378-.267h.156a2.348,2.348,0,0,1,1.78.913,3.922,3.922,0,0,1,.756,1.669V27.6c0,.312-.022.623-.044.912a18.147,18.147,0,0,1-.378,2.448,5.1,5.1,0,0,0,4.874-5.074V23.456c.044-.445.044-.912.044-1.424a21.925,21.925,0,0,0-43.841-.69Z",
    transform: "translate(0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    "data-name": "Fill",
    d: "M9.124,18.248a9.124,9.124,0,1,1,9.124-9.124A9.135,9.135,0,0,1,9.124,18.248ZM12.307.835a4.931,4.931,0,0,0-.579.034,9.5,9.5,0,0,0-1.156.2L10.1,1.2c-.22.061-.474.143-.757.246A8.724,8.724,0,0,0,6.854,2.916a7.908,7.908,0,0,0-2.56,4.095,6.472,6.472,0,0,0-.2,1.312v.089a6.705,6.705,0,0,0,.022.935,4.148,4.148,0,0,0,.157.89.169.169,0,0,0,.011.055.173.173,0,0,1,.011.056,5.9,5.9,0,0,0,.668,1.468A5.207,5.207,0,0,0,7.878,14a4.9,4.9,0,0,0,4.406-.846,4.489,4.489,0,0,0,1.313-1.58,5.2,5.2,0,0,0,.556-2.226V9.169a5.191,5.191,0,0,0-.222-1.313,4.352,4.352,0,0,0-.556-1.179l-.067-.112a4.452,4.452,0,0,0-1.269-1.157A6.016,6.016,0,0,0,10.1,4.674V4.562A3.774,3.774,0,0,1,13.063.913a.42.42,0,0,0-.178-.044A4.911,4.911,0,0,0,12.307.835Z",
    transform: "translate(12.841 2.27)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Eyes",
    transform: "translate(10.324 24.991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    "data-name": "Fill",
    d: "M8.546,2.68c-.382.328-2.082-.888-4.234-.827C2.161,1.792.461,3.008.079,2.68-.385,2.412,1.216,0,4.313,0s4.7,2.412,4.234,2.68",
    transform: "translate(14.263 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    "data-name": "Fill",
    d: "M.079,2.68c.382.328,2.082-.888,4.233-.827,2.152-.061,3.852,1.155,4.234.827C9.011,2.412,7.409,0,4.313,0S-.385,2.412.079,2.68",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mouth",
    transform: "translate(15.848 34.317)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-8",
    "data-name": "Fill",
    d: "M6.034,1.195A11,11,0,0,1,1.522.364C-.044-.409-.472.09.569,1.471A7.567,7.567,0,0,0,6.034,4.319,7.566,7.566,0,0,0,11.5,1.471c1.042-1.382.614-1.88-.952-1.108a11,11,0,0,1-4.513.831",
    fill: "#4a4d4e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Blush",
    transform: "translate(8.229 30.477)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.291,
    cy: 3.291,
    r: 3.291,
    transform: "translate(0 0)",
    fill: "rgba(230,0,0,0.2)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    "data-name": "Oval",
    cx: 3.291,
    cy: 3.291,
    r: 3.291,
    transform: "translate(20.846 0)",
    fill: "rgba(230,0,0,0.2)"
  }))));
}

var _default = ic_blush;
exports.default = _default;